import { type MouseEvent } from 'react';
import { Minus, Plus } from '@common/i18n/constants';
import classnames from '@common/utils/ui/classnames';
import createRipple from '@common/utils/ui/ripple';
import '@common/styles/components/stepButtons.pcss';

export interface StepButtonsProps {
  min: number;
  max: number;
  step: number;
  value: number;
  changeValue: (change: number) => void;
  disabled?: boolean;
}

function StepButtons({ min, max, step, value, changeValue, disabled }: Readonly<StepButtonsProps>) {
  const decreaseButtonDisabled = value <= min || disabled;
  const increaseButtonDisabled = value >= max || disabled;

  const change = (event: MouseEvent<HTMLButtonElement>, by: number) => {
    createRipple(event);
    event.stopPropagation();
    changeValue(by);
  };

  return (
    <div className="step-buttons">
      <button
        type="button"
        className={classnames({
          'step-buttons__btn': true,
          'step-buttons__btn--disabled': decreaseButtonDisabled,
        })}
        disabled={decreaseButtonDisabled}
        onClick={(event) => change(event, -step)}
        aria-label="Decrease value"
        data-testid="stepButtonDecrement"
      >
        {Minus}
      </button>
      <button
        type="button"
        className={classnames({
          'step-buttons__btn': true,
          'step-buttons__btn--disabled': increaseButtonDisabled,
        })}
        disabled={increaseButtonDisabled}
        onClick={(event) => change(event, step)}
        aria-label="Increase value"
        data-testid="stepButtonIncrement"
      >
        {Plus}
      </button>
    </div>
  );
}

export default StepButtons;
